export class ValidationError extends Error {
  override name = "ValidationError";
}
